import { supabase } from "@/lib/supabase";
import type { ProgressMap, ProjectSummary } from "./progressSummary";

// None of these throw: a network or auth failure must never block grading.
// They return null and the caller falls back to the workbook.

export async function fetchProgress(): Promise<ProgressMap | null> {
  try {
    const { data, error } = await supabase
      .from("student_progress")
      .select("progress")
      .maybeSingle();
    if (error) return null;
    return (data?.progress as ProgressMap | undefined) ?? {};
  } catch {
    return null;
  }
}

export async function recordPracticeAttempt(
  projectId: string,
  results: Record<string, boolean>,
  total: number,
  countAttempt = true
): Promise<ProjectSummary | null> {
  try {
    const { data, error } = await supabase.rpc("record_practice_attempt", {
      p_project_id: projectId,
      p_results: results,
      p_total: total,
      p_count_attempt: countAttempt,
    });
    if (error || !data) return null;
    return data as ProjectSummary;
  } catch {
    return null;
  }
}

export interface ExamRecord {
  attemptNumber: number;
  scorePassed: number;
  scoreTotal: number;
}

export async function recordExamAttempt(
  practicaId: string,
  startedAt: Date,
  results: Record<string, Record<string, boolean>>,
  clientId: string
): Promise<ExamRecord | null> {
  try {
    const { data, error } = await supabase.rpc("record_exam_attempt", {
      p_practica_id: practicaId,
      p_started_at: startedAt.toISOString(),
      p_results: results,
      p_client_id: clientId,
    });
    const row = Array.isArray(data) ? data[0] : data;
    if (error || !row) return null;
    return {
      attemptNumber: row.attempt_number,
      scorePassed: row.score_passed,
      scoreTotal: row.score_total,
    };
  } catch {
    return null;
  }
}
